var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Execution",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KA-New-UI",
    transform: "translate(-332.000000, -726.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/12px/Status/Failed",
    transform: "translate(332.000000, 726.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E05169",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(6.000000, 6.000000) rotate(-45.000000) translate(-6.000000, -6.000000) translate(2.000000, 2.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 3,
    width: 8,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(4.000000, 4.000000) rotate(-90.000000) translate(-4.000000, -4.000000) ",
    x: 0,
    y: 3,
    width: 8,
    height: 2,
    rx: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusFailed);
export default __webpack_public_path__ + "static/media/status-failed.f6d99f6eafdac7acbcf702ff8c2db836.svg";
export { ForwardRef as ReactComponent };